import { useState } from "react";
import api from "../api";
import { Modal } from "./ui";
import DateIT from "./DateIT";
import EmailComposer from "./EmailComposer";
import { WhatsAppButton } from "./WhatsAppButton";

const MODES = [
  ["presenza", "In presenza"], ["zoom", "Videoriunione Zoom"],
  ["phone", "Telefonata"], ["trasferta", "Trasferta"], ["studio", "Lavoro di studio"],
];

// Azioni rapide su un contatto (azienda o persona), disponibili ovunque.
// target = { kind: "company"|"person", id, name, email, phone, company }
export default function QuickActions({ target, size = "sm" }) {
  const [modal, setModal] = useState(null); // "email" | "appt" | "task"
  const [appt, setAppt] = useState({ date: "", time: "09:00", dur: 30, mode: "presenza", title: "" });
  const [task, setTask] = useState({ title: "", due: "" });
  const [busy, setBusy] = useState(false);
  const cls = "btn " + size;
  const isCompany = target.kind === "company";

  const saveAppt = async () => {
    if (!appt.date || !appt.time) { alert("Indica data e ora"); return; }
    setBusy(true);
    try {
      const body = isCompany
        ? { category: "cliente", company_id: target.id, company: target.name, name: target.name, mode: appt.mode, date: appt.date, time: appt.time, dur: Number(appt.dur) || 30, count_hours: true, title: appt.title }
        : { category: "lead", person_id: target.id, name: target.name, mode: appt.mode, date: appt.date, time: appt.time, dur: Number(appt.dur) || 30, count_hours: false, title: appt.title || "Incontro con Lead" };
      await api.post("/appointments", body);
      setModal(null); setAppt({ date: "", time: "09:00", dur: 30, mode: "presenza", title: "" });
      alert("Appuntamento creato nel calendario.");
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const saveTask = async () => {
    if (!task.title.trim()) { alert("Indica la descrizione dell'incarico"); return; }
    setBusy(true);
    try {
      await api.post("/tasks", { title: task.title.trim(), due_date: task.due || null, company_id: isCompany ? target.id : null });
      setModal(null); setTask({ title: "", due: "" });
      alert("Incarico assegnato.");
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  return (
    <span style={{ display: "inline-flex", gap: 6, flexWrap: "wrap", alignItems: "center" }} data-testid="quick-actions">
      {target.email && <button className={cls} onClick={() => setModal("email")} data-testid="qa-email" title={`Email a ${target.email}`}>✉️ Email</button>}
      {target.phone && <WhatsAppButton phone={target.phone} name={target.name} company={target.company} className={cls} />}
      <button className={cls} onClick={() => setModal("appt")} data-testid="qa-appt" title="Crea appuntamento">📅 Appuntamento</button>
      <button className={cls} onClick={() => setModal("task")} data-testid="qa-task" title="Assegna incarico">✅ Incarico</button>

      {modal === "email" && (
        <EmailComposer mode="new" prefillTo={target.email} onClose={() => setModal(null)} onSent={() => setModal(null)} />
      )}

      {modal === "appt" && (
        <Modal title={`Nuovo appuntamento · ${target.name}`} onClose={() => setModal(null)}>
          <div className="grid-2">
            <div className="field"><label>Data *</label><DateIT value={appt.date} onChange={(v) => setAppt({ ...appt, date: v })} data-testid="qa-appt-date" /></div>
            <div className="field"><label>Ora *</label><input type="time" value={appt.time} onChange={(e) => setAppt({ ...appt, time: e.target.value })} data-testid="qa-appt-time" /></div>
          </div>
          <div className="grid-2">
            <div className="field"><label>Durata (minuti)</label><input type="number" min="5" step="5" value={appt.dur} onChange={(e) => setAppt({ ...appt, dur: e.target.value })} /></div>
            <div className="field"><label>Tipo</label>
              <select value={appt.mode} onChange={(e) => setAppt({ ...appt, mode: e.target.value })}>
                {MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          </div>
          <div className="field"><label>Note (facoltative)</label><input value={appt.title} onChange={(e) => setAppt({ ...appt, title: e.target.value })} /></div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setModal(null)}>Annulla</button>
            <button className="btn primary" onClick={saveAppt} disabled={busy} data-testid="qa-appt-save">Crea appuntamento</button>
          </div>
        </Modal>
      )}

      {modal === "task" && (
        <Modal title={`Nuovo incarico · ${target.name}`} onClose={() => setModal(null)}>
          <div className="field"><label>Descrizione *</label><input value={task.title} onChange={(e) => setTask({ ...task, title: e.target.value })} placeholder="es. Richiamare il cliente" data-testid="qa-task-title" /></div>
          <div className="field"><label>Scadenza</label><DateIT value={task.due} onChange={(v) => setTask({ ...task, due: v })} data-testid="qa-task-due" /></div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setModal(null)}>Annulla</button>
            <button className="btn primary" onClick={saveTask} disabled={busy} data-testid="qa-task-save">Assegna incarico</button>
          </div>
        </Modal>
      )}
    </span>
  );
}
